// extracted by mini-css-extract-plugin
export default {"centered":"CampaignManageCampaignsPage_centered__CzWdk"};